import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {HttpClient} from "@angular/common/http";

/**
 * Generated class for the AdditionalServiceSuccessPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-additional-service-success',
    templateUrl: 'additional-service-success.html',
})
export class AdditionalServiceSuccessPage {

    loading: boolean;
    errors: {};

    currencySymbol: string;
    totalCost: any;
    booking: any;
    services: any;
    user: any;

    constructor(
        public navCtrl: NavController,
        public http: HttpClient,
        public apiErrorHandler: ApiErrorHandlerProvider,
        public navParams: NavParams) {
        this.currencySymbol = navParams.get('currencySymbol');
        this.services = navParams.get('services');
        this.booking = navParams.get('booking');
        this.totalCost = navParams.get('totalCost');
        this.user = this.booking.booking.user;
    }

    openMyChair() {
        this.navCtrl.popToRoot();
    }
}


// WEBPACK FOOTER //
// ./src/pages/additional-service-success/additional-service-success.ts